import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Send, LogOut, User, History, Users, Shield, Wallet, Bitcoin, CreditCard } from 'lucide-react';
import { authAPI } from '@/lib/api';

export default function Navbar() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (token) {
      checkAdminStatus();
    }
  }, [token]);

  const checkAdminStatus = async () => {
    try {
      const response = await authAPI.getMe();
      setIsAdmin(response.data.is_admin || false);
    } catch (error) {
      console.error('Failed to check admin status');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <nav className="bg-white border-b border-border/50 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex justify-between items-center h-16">
          <Link to={token ? "/dashboard" : "/"} className="flex items-center gap-2">
            <img src="/ezy-logo.png" alt="Ezy" className="h-10 w-10" />
            <span className="font-heading font-black text-2xl tracking-tighter text-primary">Transfer</span>
          </Link>
          
          {token ? (
            <div className="flex items-center gap-4">
              <Link to="/dashboard">
                <Button data-testid="nav-dashboard-btn" variant="ghost" size="sm" className="gap-2">
                  <Send className="w-4 h-4" />
                  Dashboard
                </Button>
              </Link>
              <Link to="/recipients">
                <Button data-testid="nav-recipients-btn" variant="ghost" size="sm" className="gap-2">
                  <Users className="w-4 h-4" />
                  Recipients
                </Button>
              </Link>
              <Link to="/wallet">
                <Button data-testid="nav-wallet-btn" variant="ghost" size="sm" className="gap-2">
                  <Wallet className="w-4 h-4" />
                  Wallet
                </Button>
              </Link>
              <Link to="/crypto">
                <Button data-testid="nav-crypto-btn" variant="ghost" size="sm" className="gap-2">
                  <Bitcoin className="w-4 h-4" />
                  Crypto
                </Button>
              </Link>
              <Link to="/pos">
                <Button data-testid="nav-pos-btn" variant="ghost" size="sm" className="gap-2">
                  <CreditCard className="w-4 h-4" />
                  POS
                </Button>
              </Link>
              <Link to="/transactions">
                <Button data-testid="nav-transactions-btn" variant="ghost" size="sm" className="gap-2">
                  <History className="w-4 h-4" />
                  History
                </Button>
              </Link>
              {isAdmin && (
                <Link to="/admin">
                  <Button data-testid="nav-admin-btn" variant="ghost" size="sm" className="gap-2">
                    <Shield className="w-4 h-4" />
                    Admin
                  </Button>
                </Link>
              )}
              <Link to="/profile">
                <Button data-testid="nav-profile-btn" variant="ghost" size="sm" className="gap-2">
                  <User className="w-4 h-4" />
                  Profile
                </Button>
              </Link>
              <Button data-testid="logout-btn" onClick={handleLogout} variant="outline" size="sm" className="gap-2">
                <LogOut className="w-4 h-4" />
                Logout
              </Button>
            </div>
          ) : (
            <div className="flex gap-3">
              <Link to="/login">
                <Button data-testid="nav-login-btn" variant="outline">Login</Button>
              </Link>
              <Link to="/register">
                <Button data-testid="nav-register-btn" className="bg-accent hover:bg-accent/90">Get Started</Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}